import { Blured } from "@components/blured";
import { formatDate, formatTime } from "@helpers/date";
import { getProfit, ProfitServerData } from "@request/profit";
import { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import styles from "./chart.module.scss";

export type ProfitFilterType = "day" | "week" | "month" | "year";
export type ProfitTransactionFilterType = "pay-in" | "pay-out" | "income";

type Props = {
  type: ProfitFilterType;
};

const formatDateByType = (date: Date, type: ProfitFilterType) => {
  if (type === "day") {
    return formatTime(date);
  }

  if (type === "year") {
    return formatDate(date, "LLLL");
  }

  return formatDate(date, "dd MMMM");
};

export const ProfitChart = ({ type }: Props) => {
  const [profit, setProfit] = useState<ProfitServerData[]>([]);

  useEffect(() => {
    getProfit(type).then((data) => {
      setProfit(
        data.map((item) => ({
          ...item,
          date: formatDateByType(new Date(item.date), type),
        }))
      );
    });
  }, [type]);

  return (
    <Blured text="Будет позже" className={styles.container}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={profit}>
          <XAxis
            dataKey="date"
            tickLine={false}
            axisLine={false}
            // axisLine={{ fill: "red", stroke: "red", strokeWidth: 2 }}
          />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip />
          <CartesianGrid stroke="#F1F3F3" />
          <Line
            type="monotone"
            dataKey="sum"
            stroke="#FECAB3"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </Blured>
  );
};
